import { CharacterCount } from '.';
import type {
   CharacterCountOptions,
   CharacterCountStorage,
} from '@tiptap/extension-character-count';

interface CustomCharacterCountOptions extends CharacterCountOptions {
   minCharacters: number;
}

interface CustomCharacterCountStorage extends CharacterCountStorage {
   minCharacters: number;
   maxCharacters: number;
}

export interface CharacterCountConfig {
   minCharacters?: number;
   maxCharacters?: number;
}

export const CustomCharacterCount = CharacterCount.extend<
   CustomCharacterCountOptions,
   CustomCharacterCountStorage
>({
   addOptions() {
      return {
         ...this.parent?.(),
         minCharacters: 0,
      };
   },
   addStorage() {
      return {
         ...this.parent?.(),
         minCharacters: this.options.minCharacters,
         maxCharacters: this.options.limit,
      };
   },
});
